export default __webpack_public_path__ + "static/media/Preferences.47e72622.png";